import { render, staticRenderFns } from "./CollectiveRequestCard.vue?vue&type=template&id=c9a6c1a0&scoped=true&"
import script from "./CollectiveRequestCard.vue?vue&type=script&lang=js&"
export * from "./CollectiveRequestCard.vue?vue&type=script&lang=js&"
import style0 from "./CollectiveRequestCard.vue?vue&type=style&index=0&id=c9a6c1a0&scoped=true&lang=css&"
import style1 from "./CollectiveRequestCard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a6c1a0",
  null
  
)

export default component.exports